export type ApiUiEvent =
  | { type: 'service_unavailable'; message: string; title?: string }
  | { type: 'session_issue'; message: string; requiresRelogin?: boolean; title?: string }
  | { type: 'insufficient_wallet_balance'; message: string; title?: string }
  | { type: 'subscription_required'; message: string; title?: string }
  | { type: 'rate_limited'; message: string; title?: string }
  | { type: 'patient_consent_required'; message: string; title?: string; patientUserId?: number };

const EVENT_NAME = 'zivo:api-ui-event';

let lastEmitAt = 0;
let lastSignature: string | null = null;
const MIN_INTERVAL_MS = 4000;

export function emitApiUiEvent(event: ApiUiEvent) {
  // Avoid spamming identical popups when multiple parallel requests fail.
  const now = Date.now();
  const signature = `${event.type}:${event.message}:${event.title ?? ''}`;
  if (now - lastEmitAt < MIN_INTERVAL_MS && lastSignature === signature) return;
  lastEmitAt = now;
  lastSignature = signature;

  try {
    window.dispatchEvent(new CustomEvent<ApiUiEvent>(EVENT_NAME, { detail: event }));
  } catch {
    // Ignore (non-browser environments)
  }
}

export function subscribeApiUiEvents(handler: (event: ApiUiEvent) => void) {
  const listener = (e: Event) => {
    const ce = e as CustomEvent<ApiUiEvent>;
    if (ce?.detail) handler(ce.detail);
  };
  window.addEventListener(EVENT_NAME, listener as EventListener);
  return () => window.removeEventListener(EVENT_NAME, listener as EventListener);
}

